type Tier = 'A' | 'B' | 'C' | 'needs_support';

// Platform semantic tokens only — no ad-hoc palette colours (see house style
// in features/Dashboard/home: bg-card / border-border / bg-muted / --primary /
// --destructive). Tiers read as a strength gradient using tint intensity
// rather than a rainbow of hues.
const TIER_STYLES: Record<Tier, string> = {
  A: 'bg-primary/10 text-primary',
  B: 'bg-muted text-foreground',
  C: 'bg-muted text-muted-foreground',
  needs_support: 'bg-destructive/10 text-destructive',
};

export const TIER_LABELS: Record<Tier, string> = {
  A: 'Tier A',
  B: 'Tier B',
  C: 'Tier C',
  needs_support: 'Support',
};

export function TierBadge({ tier }: { tier: string }) {
  const t = (tier as Tier) in TIER_STYLES ? (tier as Tier) : 'C';
  return (
    <span className={`inline-block rounded-full px-2 py-0.5 text-[10px] font-bold ${TIER_STYLES[t]}`}>
      {TIER_LABELS[t]}
    </span>
  );
}
